module.exports = __webpack_public_path__ + "img/6EC66E_C9F8C9_A3E8A3_B4F1B4-256px.4a547ebc.png";